class dateFormat {
  static date(date) {
    return date ? new Date(date).toLocaleDateString('pt-BR') : null;
  }

  static time(date) {
    return date ? new Date(date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : null;
  }

  static dateTime(date) {
    var data = this.date(date);
    var hora = this.time(date);
    return data && hora ? data + ' - ' + hora : null;
  }
}

export default dateFormat;